(function () {
  const pricingElement = document.getElementById('bac-hero-pricing');

  if (!pricingElement) return;

  let pricing;

  try {
    pricing = JSON.parse(pricingElement.textContent);
  } catch (error) {
    console.error('2B Hero: Invalid pricing JSON.', error);
    return;
  }

  const assets = window.bacAssets || {};

  const flavourImages = {
    Mint: {
      src: assets.mint,
      alt: '2baconil Mint gum pack',
      tagBg: 'var(--teal)'
    },
    Paan: {
      src: assets.paan,
      alt: '2baconil Paan gum pack',
      tagBg: 'var(--green)'
    }
  };

  let selectedFlavour = 'Mint';
  let selectedCount = 30;

  const flavourButtons = Array.from(
    document.querySelectorAll('#flavourRow .opt')
  );

  const packButtons = Array.from(
    document.querySelectorAll('#packRow .opt')
  );

  const productImg = document.getElementById('productImg');
  const flavourTag = document.getElementById('flavourTag');
  const flavourTagLabel = document.getElementById('flavourTagLabel');

  const priceValue = document.getElementById('priceValue');
  const priceOld = document.getElementById('priceOld');
  const buyBtn = document.getElementById('buyBtn');

  // Discount and savings elements
  const discountBadge = document.getElementById('heroDiscount');
  const savingsAmount = document.getElementById('heroSave');
  const savingsWrap = document.getElementById('heroSaveWrap');

  if (!productImg || !priceValue || !buyBtn) return;

  const GUM_URL =
    'https://www.2baconil.com/collections/nicotine-chewing-gum/products/';

  const buyLinks = {
    Mint: {
      30: '2baconil-gums-2mg-mint-flavour-tin-30-gums',
      60: '2baconil-gums-2mg-mint-flavour-tin-60-gums-pack-of-2',
      90: '2baconil-gums-2mg-mint-flavour-tin-90-gums-pack-of-3',
      120: '2baconil-gums-2mg-mint-flavour-tin-180-gums-pack-of-4'
    },
    Paan: {
      30: '2baconil-gums-2mg-paan-flavour-tin-30-gums',
      60: '2baconil-gums-2mg-paan-flavour-tin-60-gums-pack-of-2',
      90: '2baconil-gums-2mg-paan-flavour-tin-90-gums-pack-of-3',
      120: '2baconil-gums-2mg-paan-flavour-tin-120-gums-pack-of-4'
    }
  };

  // Preserve existing product image behaviour
  const embeddedProductImage = productImg.currentSrc || productImg.src;

  document.querySelectorAll('[data-shop-product-image]').forEach(image => {
    image.src = embeddedProductImage;
  });

  function formatPrice(value) {
    const amount = Number(value);

    return '₹' + (Number.isFinite(amount) ? amount : 0).toFixed(2);
  }

  function render() {
    const info = flavourImages[selectedFlavour];

    const currentPricing =
      pricing[selectedFlavour] &&
      pricing[selectedFlavour][selectedCount];

    if (!currentPricing) return;

    const sellingPrice = Number(currentPricing.price) || 0;
    const oldPrice = Number(currentPricing.oldPrice) || 0;

    // Calculate savings and discount percentage ONCE
    const savings = Math.max(0, oldPrice - sellingPrice);

    const discountPercentage = oldPrice > 0
      ? Math.round((savings / oldPrice) * 100)
      : 0;

    // Update product image
    if (info && info.src) {
      productImg.src = info.src;
    }

    if (info) {
      productImg.alt = info.alt;
    }

    // Update flavour label
    if (flavourTagLabel) {
      flavourTagLabel.textContent = selectedFlavour;
    }

    if (flavourTag && info) {
      flavourTag.style.background = info.tagBg;
    }

    // Update selling price
    priceValue.textContent = formatPrice(sellingPrice);

    // Update old price
    if (priceOld) {
      priceOld.textContent = formatPrice(oldPrice);
    }

    // Get editable labels from Shopify Customizer
    const displaySettings = pricing.display || {};

    const discountSuffix =
      displaySettings.discountSuffix || '% off';

    const saveLabel =
      displaySettings.saveLabel || 'You save';

    // Update discount percentage
    if (discountBadge) {
      discountBadge.textContent =
        discountPercentage + discountSuffix;

      discountBadge.hidden = savings <= 0;
    }

    // Update savings amount
    if (savingsAmount) {
      savingsAmount.textContent =
        saveLabel + ' ' + formatPrice(savings);
    }

    // Hide savings when there is no discount
    if (savingsWrap) {
      savingsWrap.hidden = savings <= 0;
    }

    // Update Buy button text
    buyBtn.textContent =
      `Buy ${selectedFlavour} · ${selectedCount} gums →`;

    // Update Buy button link
    const productHandle =
      buyLinks[selectedFlavour] &&
      buyLinks[selectedFlavour][selectedCount];

    if (productHandle) {
      buyBtn.href = GUM_URL + productHandle;
    }
  }

  // Mint / Paan flavour selection
  flavourButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      selectedFlavour = btn.dataset.flavour;

      flavourButtons.forEach(button => {
        const active = button === btn;

        button.classList.toggle('active', active);
        button.setAttribute('aria-selected', String(active));
      });

      render();
    });
  });

  // Pack-size selection
  packButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      selectedCount = Number(btn.dataset.count);

      packButtons.forEach(button => {
        const active = button === btn;

        button.classList.toggle('active', active);
        button.setAttribute('aria-checked', String(active));
      });

      render();
    });
  });

  // Initial render
  render();
})();

(function () {
  const cards = document.querySelectorAll('#videoGrid .video-card');
  if (!cards.length) return;
  if (!('IntersectionObserver' in window)) {
    cards.forEach(c => c.classList.add('in-view'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.25 });
  cards.forEach(c => io.observe(c));
})();

document.querySelectorAll('.faq-item').forEach(item => {
  item.querySelector('.faq-q').addEventListener('click', () => {
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});
